import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { Star } from "lucide-react";

export default function TenantCategory() {
  const { slug, catId } = useParams();
  const [services, setServices] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get(`/public/tenant/${slug}/services?category_id=${catId}`),
      api.get(`/public/tenant/${slug}/categories`).then((r) => r.data.find((c) => c.id === catId)),
    ]).then(([s, c]) => { setServices(s.data); setCategory(c); });
  }, [slug, catId]);

  return (
    <div className="px-5 py-5 md:px-6 md:py-8" data-testid="tenant-category-page">
      {category && (
        <div className="mb-5 md:mb-8">
          <div className="rounded-2xl overflow-hidden aspect-[16/9] md:aspect-[21/6] brand-muted">
            {category.image_url && <img src={category.image_url} alt="" className="h-full w-full object-cover" />}
          </div>
          <h1 className="brand-heading text-2xl md:text-3xl font-bold mt-4 break-words">{category.name}</h1>
          <p className="text-sm brand-text-muted mt-1">{category.description}</p>
        </div>
      )}

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3 md:gap-4" data-testid="tenant-category-services-list">
        {services.length === 0 && <div className="text-sm brand-text-muted text-center py-10 md:col-span-2 xl:col-span-3">No services here yet.</div>}
        {services.map((s) => (
          <Link key={s.id} to={`/t/${slug}/service/${s.id}`} className="brand-card flex gap-3 p-3 overflow-hidden" data-testid={`tenant-cat-service-${s.id}`}>
            <div className="h-24 w-24 rounded-xl brand-muted overflow-hidden flex-shrink-0">
              {s.images?.[0] && <img src={s.images[0]} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[11px] brand-text-muted flex items-center gap-1">
                <Star className="h-3 w-3 fill-current" style={{ color: "#FBBF24" }} /> {s.rating?.toFixed(1) || "4.5"} ({s.total_reviews})
              </div>
              <div className="font-bold mt-0.5 leading-tight break-words">{s.name}</div>
              <div className="text-xs brand-text-muted line-clamp-2 mt-1">{s.description}</div>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <div className="font-bold">{formatINR(s.discount_price || s.price)}</div>
                {s.discount_price && <div className="text-xs line-through brand-text-muted">{formatINR(s.price)}</div>}
                <div className="text-[10px] brand-text-muted ml-auto">{s.duration_minutes} min</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
